'use client';
import DetailHeaderActions from './DetailHeaderActions';
import HIHImageCaption from '../base/ImageCaption';
import { ArticleDetail } from '@/sanity/fetchArticleDetail';
import { useEffect, useState } from 'react';

interface ArticleDetailHeaderProps {
  title: ArticleDetail['title'];
  coverImage: ArticleDetail['coverImage'];
  shortDescription: ArticleDetail['shortDescription'];
}

export default function ArticleDetailHeader({
  title,
  coverImage,
  shortDescription,
}: ArticleDetailHeaderProps) {
  const [showSkeleton, setShowSkeleton] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowSkeleton(false);
    }, 200);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <DetailHeaderActions href="/" />

      <div className="lg:flex lg:gap-x-6xl">
        <div className="lg:order-2 lg:basis-[66%] xl:basis-[58%]">
          {showSkeleton ? (
            <div className="rounded-2xl object-cover max-h-[270px] w-full h-[270px] lg:max-h-full lg:h-[510px] bg-sys/primary/primary-container animate-pulse" />
          ) : (
            <HIHImageCaption
              captionAsOverlay
              image={coverImage}
              width={1600}
              height={1200}
              className="lg:h-full"
              imageClassName="rounded-2xl object-cover h-[270px] md:h-auto aspect-21/9 lg:aspect-4/3 xl:min-w-[680px] lg:h-full"
            />
          )}
        </div>

        <div className="lg:order-1 lg:min-w-[488px] lg:basis-[34%] xl:basis-[42%]">
          <h1 className="uppercase font-display text-headline-lg lg:text-display-lg my-3xl lg:mt-0 lg:mb-5xl">
            {title}
          </h1>
          <p>{shortDescription}</p>
        </div>
      </div>
    </>
  );
}
